import { render, staticRenderFns } from "./indexNews.vue?vue&type=template&id=249202ab&scoped=true&"
import script from "./indexNews.vue?vue&type=script&lang=js&"
export * from "./indexNews.vue?vue&type=script&lang=js&"
import style1 from "./indexNews.vue?vue&type=style&index=1&id=249202ab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "249202ab",
  null
  
)

export default component.exports